import { Injectable, EventEmitter, Output  } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  emitters                      = {}; 
  @Output() base_layer          = new EventEmitter<String>();
  @Output() logget_user         = new EventEmitter<String>();

  constructor() { }    
    
  addEventEmitter(label)
  {
    this.emitters[label] = new EventEmitter<any>();
  }

  getEventEmitter(label)
  {
    return this.emitters[label].asObservable();
  }

  updateEmitter(label, value)
  {
    this.emitters[label].emit(value);
  }

  //**** VERY SPECIFIC METHODS FOR BASE LAYER. TO BE REFACTORIZED */
  updateBaseLayer(base_layer_name)
  {
    this.base_layer.emit(base_layer_name);
  }

  updateLoggedUser(username)
  {
    this.logget_user = username;
  }



}
